import { format } from "date-fns";

export function formatDate(date: any, theFormat?: string) {
   if (!date) return "";
   const dateSafari = date.replace(/-/g, "/");
   return format(new Date(dateSafari), theFormat ?? "dd-MM-yyyy");
}
